export default __webpack_public_path__ + "static/media/reports-20.f6bffa94.png";